import React, { useRef } from "react";
import { createPortal } from "react-dom";

import { useModalA11y } from "@/hooks/use-modal-a11y";

import { Button } from "./button";

interface LoginPromptModalDiscoveryProps {
	open: boolean;
	onClose: () => void;
	onLogin: () => void;
}

const LoginPromptModalDiscovery: React.FC<LoginPromptModalDiscoveryProps> = ({ open, onClose, onLogin }) => {
	const modalRef = useRef<HTMLDivElement>(null);
	useModalA11y(open, modalRef);

	if (!open)
		return null;

	return createPortal(
		<div
			ref={modalRef}
			role="dialog"
			aria-modal="true"
			aria-labelledby="login-prompt-title"
			className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 animate-fadeIn"
			onClick={onClose}
			tabIndex={-1}
			onKeyDown={(e) => {
				if (e.key === "Escape") {
					onClose();
				}
			}}
		>
			<div
				className="relative bg-white shadow-2xl border border-[#ececff] animate-scaleIn text-center p-4 rounded-2xl w-full max-w-xs sm:p-6 sm:rounded-3xl sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
				onClick={e => e.stopPropagation()}
				style={{ boxShadow: "0 8px 32px rgba(63,46,200,0.12)", margin: "12vh 0", minHeight: "auto", maxHeight: "76vh", overflowY: "auto" }}
			>
				{/* Close button */}
				<button
					className="rounded-full p-1 transition-colors duration-150 hover:bg-gray-200"
					style={{ position: "absolute", top: 12, right: 16, lineHeight: 1, border: "none", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10 }}
					onClick={onClose}
					aria-label="Close"
				>
					<img
						src="/assets/icons/close.svg"
						alt="Close"
						style={{ width: 24, height: 24, display: "block" }}
					/>
				</button>
				{/* Icon */}
				<div className="flex justify-center mb-4">
					<div className="bg-[#3F2EC8] bg-opacity-10 rounded-full p-3 flex items-center justify-center">
						<img
							src="/assets/icons/profile.svg"
							alt="Profile"
							style={{
								width: 36,
								height: 36,
								display: "block",
								filter: "brightness(0.5) drop-shadow(0 2px 6px rgba(63,46,200,0.18))",
								borderRadius: "50%"
							}}
						/>
					</div>
				</div>
				<h2 id="login-prompt-title" className="text-2xl font-bold text-[#3F2EC8] mb-2">Authentication Required</h2>
				<p className="mb-6 text-gray-700 text-base">Please sign in to continue.</p>
				<div className="flex flex-col gap-3 items-center">
					<Button
						className="w-full"
						onClick={onLogin}
					>
						Go to Login
					</Button>
				</div>
			</div>
		</div>,
		document.body
	);
};

export default LoginPromptModalDiscovery;
